import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { StandardFilterCounter } from "../filters/StandardFilterCounter"
import { StandardButton } from "../buttons/StandardButton"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilter } from "@fortawesome/pro-light-svg-icons"

export const StandardFilterButton = ({
    onClick,
    activeCount,
    className,
}: {
    onClick: () => void
    activeCount: number
    className?: string
}) => {
    return (
        <StandardButton
            fullWidth={false}
            size="small"
            variant="outlined"
            onClick={onClick}
            className={className}
            startIcon={<FontAwesomeIcon icon={faFilter} />}
        >
            <LocalizedStrict id="table-filters-button">
                <>Filters</>
            </LocalizedStrict>
            <StandardFilterCounter show={Boolean(activeCount)} counter={activeCount} />
        </StandardButton>
    )
}
